import { defineStore } from 'pinia';

export const useMemberStore = defineStore('member',{
  state: () => ({
    memberSeq: 0,
    memberId:"",
    memberName:"",
    memberGroupSeq: 0,
    memberGroupName:"",
    status:"",
    mobilePhone:"",
    email:"",
    birthday:"",
    sex:"",
    groupUpdateDate:"",
    emoney: 0,
    emoneyPercent: 0,
    zipCode:"",
    address:"",
    roadAddress:"",
    addressDetail:"",
    smsAgreeYn: false,
    age: 0,
    usableEmoney: false,
    isStaff : false,
    freeShippingYn : false,
    isGradedMember : false, //등급제 적용회원 
  }),
  getters: {
    
  },
  actions: {
    // 사용자 정보설정
    saveMemberInfo(memberInfo : Record<string,any> | null) {
      if (memberInfo == null || Object.keys(memberInfo).length == 0 ) return;

      this.memberSeq = memberInfo.memberSeq
      this.memberId = memberInfo.memberId
      this.memberName = memberInfo.memberName
      this.memberGroupSeq = memberInfo.memberGroupSeq
      this.memberGroupName = memberInfo.memberGroupName
      this.status = memberInfo.status
      this.mobilePhone = memberInfo.mobilePhone
      this.email = memberInfo.email
      this.birthday = memberInfo.birthday
      this.sex = memberInfo.sex
      this.groupUpdateDate = memberInfo.groupUpdateDate
      this.emoney = memberInfo.emoney
      this.emoneyPercent = memberInfo.emoneyPercent
      this.zipCode = memberInfo.zipCode
      this.address = memberInfo.address
      this.roadAddress = memberInfo.roadAddress
      this.addressDetail = memberInfo.addressDetail
      this.smsAgreeYn = memberInfo.smsAgreeYn
      this.age = memberInfo.age
      this.usableEmoney = memberInfo.usableEmoney
      this.isStaff = [4, 9, 14, 15, 16, 17, 18, 20, 21, 23, 24, 25, 28, 29, 31, 32, 35].includes(memberInfo.memberGroupSeq)
      this.freeShippingYn = memberInfo.freeShippingYn
      this.isGradedMember = memberInfo.memberGroupType == "Auto" //등급제 대상회원 = 자동회원그룹에 속함 (플래티넘,플래티넘P)
    },
    //  초기화
    clearMemberInfo() {
      this.memberSeq = 0;
      this.memberId = "";
      this.memberName = "";
      this.memberGroupSeq = 0;
      this.memberGroupName = "";
      this.status = "";
      this.mobilePhone = "";
      this.email = "";
      this.birthday = "";
      this.sex = "";
      this.groupUpdateDate = "";
      this.emoney = 0;
      this.emoneyPercent = 0;
      this.zipCode = "";
      this.address = "";
      this.roadAddress = "";
      this.addressDetail = "";
      this.smsAgreeYn = false;
      this.age = 0;
      this.usableEmoney = false;
      this.isStaff = false;
      this.freeShippingYn = false;
      this.isGradedMember = false; 
    }
  },
});